import { c as _c } from "react/compiler-runtime";
/* eslint react/jsx-props-no-spreading: 0 */
import type { CSSProperties, JSX } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import type { SpacingValue } from '../../../theme';
import { Padding } from '../../padding';
interface ExpandableBodyProps {
  // eslint-disable-next-line
  id?: string;
  expandableHeaderId?: string;
  getCollapseProps?: any;
  children: React.ReactNode;
  paddingX?: SpacingValue;
  paddingBottom?: SpacingValue;
  defaultOverflow?: CSSProperties['overflow'];
  backgroundColor?: CSSProperties['backgroundColor'];
}
export const ExpandableBody = t0 => {
  const $ = _c(15);
  const {
    id,
    expandableHeaderId,
    getCollapseProps,
    children,
    paddingX: t1,
    paddingBottom: t2,
    defaultOverflow: t3,
    backgroundColor: t4
  } = t0;
  const paddingX = t1 === undefined ? 24 : t1;
  const paddingBottom = t2 === undefined ? 24 : t2;
  const defaultOverflow = t3 === undefined ? "hidden" : t3;
  const backgroundColor = t4 === undefined ? "none" : t4;
  let t5;
  if ($[0] !== getCollapseProps) {
    t5 = getCollapseProps();
    $[0] = getCollapseProps;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    id: collapseId
  } = t5;
  let t6;
  if ($[2] !== getCollapseProps) {
    t6 = getCollapseProps();
    $[2] = getCollapseProps;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = id ?? collapseId;
  let t8;
  if ($[4] !== children || $[5] !== paddingBottom || $[6] !== paddingX) {
    t8 = <Padding bottom={paddingBottom} x={paddingX}>{children}</Padding>;
    $[4] = children;
    $[5] = paddingBottom;
    $[6] = paddingX;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== backgroundColor || $[9] !== defaultOverflow || $[10] !== expandableHeaderId || $[11] !== t6 || $[12] !== t7 || $[13] !== t8) {
    t9 = <StyledBody backgroundColor={backgroundColor} defaultOverflow={defaultOverflow} {...t6} role="region" aria-labelledby={expandableHeaderId} id={t7}>{t8}</StyledBody>;
    $[8] = backgroundColor;
    $[9] = defaultOverflow;
    $[10] = expandableHeaderId;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
const StyledBody = styled.div<ExpandableBodyProps>`
  background-color: ${({
  backgroundColor
}) => backgroundColor};
  overflow: ${({
  defaultOverflow
}) => defaultOverflow};
`;